<template>
  <div class="content-bottom-item" :style="{ width }" @click.stop="trigger">
    <slot>
      <img v-if="isUp" v-lazy="url" />
      <img v-else v-lazy="url1" />
      <span>{{upCount ? upCount : (label !=='' ? label : '点赞')}}</span>
    </slot>
  </div>
</template>
<script>
// import { Toast } from 'vant'
export default {
  props: {
    width: {
      type: String,
      default: '43px'
    },
    url: {
      type: String,
      default: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/love-block.svg'
    },
    url1: {
      type: String,
      default: 'http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/love-grey.svg'
    },
    label: {
      type: String
      // default: '点赞'
    },
    isUp: {
      type: Boolean,
      default: false
    },
    upCount: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      disabled: false
    }
  },
  methods: {
    trigger () {
      // if (this.disabled) {
      //   Toast.fail('请勿频繁操作！')
      //   return
      // }
      this.disabled = true
      this.$emit('click', () => {
        this.disabled = false
      })
    }
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
.content-bottom-item {
  display: flex;
  align-items: center;
  width: 43px;
  margin-left: 17px;
  img {
    width: 15px;
    height: 15px;
    display: inline-block;
    margin-right: 2px;
  }
  span {
    font-size: 13px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    line-height: 18px;
    white-space: nowrap;
  }
  &:last-child {
    margin-right: 0;
  }
}
</style>
